export default __webpack_public_path__ + "static/media/AnnLogo.0a052fca.svg";